import ExternalLink from '../components/ExternalLink'
import { Page } from './types'

const render = () => <p>
        MongoDB is an easy database to use with Gurobi Cluster Manager. MongoDB can be run
        in a Docker container and a <ExternalLink href="https://hub.docker.com/_/mongo">base image</ExternalLink> is available freely.
        You can start a MongoDB server using <code>docker run -p27017:27017 mongo:latest</code>. This
        will make MongoDB accessible on the host machine at port 27017. Note that for real usage you
        should mount a folder to <code>/data/db</code> to ensure your data is persisted when the container is
        destroyed. The connection string to use for Cluster Manager in the next steps will then
        be <code>mongodb://mongodb:27017</code>
</p>

const DockerDatabase: Page<{}> = {
        'key': 'docker-database',
        'title': 'Docker image for Mongo DB',
        render
}

export default DockerDatabase
